import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

/**
 * The inline "… →" link used to move between related pages. The arrow shifts
 * on hover using `transform` only, so nothing around it reflows.
 */
export function ArrowLink({
  to,
  children,
  className,
}: {
  to: string
  children: ReactNode
  className?: string
}) {
  return (
    <Link
      to={to}
      className={cn(
        'group inline-flex items-center gap-1.5 text-[13.5px] font-bold text-primary transition-colors hover:text-primary-hover',
        className,
      )}
    >
      <span className="underline-offset-4 group-hover:underline">{children}</span>
      <span
        aria-hidden="true"
        className="transition-transform duration-200 ease-brand group-hover:translate-x-0.5"
      >
        →
      </span>
    </Link>
  )
}
